import React, { useState, useRef, useEffect } from 'react'
import SbEditable from 'storyblok-react'
import Headline from '../atoms/Headline'
import Richtext from 'gatsby-theme-kn/src/components/atoms/Richtext'

const FaqBlock = ({ block }) => {
  const [activeAccordionState, setActiveAccordionState] = useState(null)
  const refContainers = useRef([])

  const refContainersCollection = (el) => {
    if (el && !refContainers.current.includes(el)) {
      refContainers.current.push(el)
    }
  }

  // Workaround: Verhindert falsche Start-Höhe des Contents, weil Bild zu lange zum Laden braucht. => Refactoring
  useEffect(() => {
    setTimeout(() => {
      setActiveAccordionState(null)
    }, 1000)
  }, [])

  const toggleAccordion = (index) => {
    const newActiveAccordionState =
      activeAccordionState !== index ? index : null
    setActiveAccordionState(newActiveAccordionState)
    /* console.log(refContainers?.current[index]?.scrollHeight) */
  }

  return (
    <SbEditable content={block}>
      <section className="faq-block">
        <div className="faq-block-container">
          <Headline headline={block.headline} />
          {block.faq_items.map((item, index) => (
            <div key={index}>
              <button
                className={`faq-block-question ${
                  activeAccordionState === index ? 'active' : ''
                }`}
                onClick={() => toggleAccordion(index)}
              >
                {item.question}
                <i className="fal fa-chevron-down"></i>
              </button>
              <div
                className="faq-block-answer"
                ref={refContainersCollection}
                style={{
                  height: `${
                    activeAccordionState === index
                      ? `${refContainers?.current[index]?.scrollHeight}px`
                      : '0px'
                  }`,
                }}
              >
                <Richtext
                  className="faq-block-answer-text"
                  text={item.answer}
                />
              </div>
            </div>
          ))}
        </div>
      </section>
    </SbEditable>
  )
}

export default FaqBlock
